<template>
  <el-dialog
    :title="ruleForm.staffId ?'修改鉴定师信息':'新增鉴定师'"
    :visible.sync="visible"
    width="480px"
    append-to-body
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      label-width="110px">
      <el-form-item
        label="鉴定师姓名:"
        prop="staffName">
        <el-input v-model="ruleForm.staffName"></el-input>
      </el-form-item>
      <el-form-item
        label="鉴定师账号:"
        prop="account">
        <el-input
          v-if="!ruleForm.staffId"
          v-model="ruleForm.account"></el-input>
        <span v-else>{{ ruleForm.account }}</span>
      </el-form-item>
      <el-form-item
        label="当前角色:"
        prop="operType">
        <oper-type-select v-model="ruleForm.operType" />
      </el-form-item>
      <el-form-item
        label="鉴定等级:"
        prop="appraisalerLevel">
        <custom-select
          v-model="ruleForm.appraisalerLevel"
          :options="ImageAppraisalerLevel">
        </custom-select>
      </el-form-item>
      <el-form-item
        label="真实姓名:"
        prop="certName">
        <el-input v-model="ruleForm.certName"></el-input>
      </el-form-item>
      <el-form-item
        label="身份证号:"
        prop="certNo">
        <el-input
          v-model="ruleForm.certNo"
          :maxlength="18"></el-input>
      </el-form-item>

      <el-form-item
        label="邮箱:"
        prop="email">
        <el-input v-model="ruleForm.email"></el-input>
      </el-form-item>
    </el-form>
    <el-alert
      v-if="!ruleForm.staffId"
      title="默认密码：123456"
      type="success"
      :closable="false">
    </el-alert>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="visible = false">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import OperTypeSelect from './oper-type-select.vue'
import Online from '../../../../service/online'
import InputValidateRules from '@/utils/input-validate-rules'
import CustomSelect from '@/components-v2/custom-select.vue'
import { ImageAppraisalerLevel } from '../../index'
export default {
  name: 'EditStaffModal',
  components: { OperTypeSelect, CustomSelect },
  props: { callback: { type: Function }},
  data() {
    return {
      // operType,
      loading: false,
      visible: false,
      ImageAppraisalerLevel,
      ruleForm: { staffId: null, account: '', staffName: '', userType: 155, operType: 21, certName: '', certNo: '', appraisalerLevel: 1, email: '' },
      rules: {
        staffName: InputValidateRules.commomWord('鉴定师姓名'),
        certName: InputValidateRules.commomWord('真实姓名'),
        certNo: InputValidateRules.checkCertNumber('身份证号'),
        account: InputValidateRules.commomWord('鉴定师账号'),
        email: InputValidateRules.checkEmail('邮箱')
      }
    }
  },
  computed: {
    title({ ruleForm }) {
      return (ruleForm.staffId ? '修改' : '新增') + '鉴定师'
    }
  },
  methods: {
    handleClosed() {
      this.ruleForm = { ...this.ruleForm, ...this.$options.data().ruleForm }
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate()
      })
    },
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.loading = true
          const { staffId } = this.ruleForm
          const dispatch = staffId ? 'updatestaff' : 'addstaff'
          Online[dispatch]({ ...this.ruleForm })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.loading = false
                this.visible = false
                this.$message.success(staffId ? '修改成功' : '新增成功')
                this.$emit('fetch')
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        }
      })
    },
    update(options = {}) {
      this.ruleForm = { ...this.ruleForm, ...options }
      this.visible = true
    }
  }
}
</script>
